<template>
    <div class="search">

        <div class="container">
            <div class="grid justify-center">

                <div class="col-sm-10 col-md-8">
                    <h1>Suche</h1>
                    <div class="search__input">
                        <input v-model="searchTerm" v-on:keyup.enter="searchArticles" placeholder="Suchbegriff...">
                        <div @click="searchArticles" class="search__input__button"></div>
                    </div>

                    <!-- Show this if user hasn't searched yet -->
                    <div v-if="!articles" class="search__empty">
                        <div class="search__empty__item"></div>
                        <div class="search__empty__item"></div>
                        <div class="search__empty__item"></div>
                    </div>
                    
                    <template v-if="articles">
                        <NewsCard v-for="article in articles" v-bind:key="article.id" :article="article" :horizontal="true"/>
                    </template>
                </div>

            </div> <!-- Close .grid -->
        </div> <!-- Close .container -->

    </div> <!-- Close .team -->
</template>

<script>
import NewsCard from '@/components/NewsCard.vue';

export default {
    name: 'SearchView',
    data() {
        return {
            searchTerm: null,
            articles: null,
        }
    },
    components: {
        NewsCard
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {

        },
        searchArticles() {
            this.$store.dispatch('searchArticles', {searchTerm: this.searchTerm}).then((res) => {
                this.articles = res.items;
            });
        }
    }
}
</script>

<style lang="scss">

    .search {
        margin: 0 0 32px;

        @media (min-width: $breakpoint-sm) {
            margin: 48px 0;
        }

        &__input {
            position: relative;
            background: $colorWhite;
            border: 1px solid rgba(27,14,32,0.06);
            box-shadow: 0 0 0 1px rgba($colorBlack, .06), 0 2px 8px 0 rgba($colorBlack, .02);
            border-radius: 12px;
            margin-bottom: 16px;

            @media (min-width: $breakpoint-sm) {
                margin-top: 48px;
                margin-bottom: 24px;
            }

            input {
                all: unset;
                width: calc(100% - 64px);
                font-size: 17px;
                line-height: 20px;
                color: $colorBlack;
                padding: 15px 0 15px 20px;

                @media (min-width: $breakpoint-sm) {
                    padding: 19px 0 19px 24px;
                    font-weight: 600;
                }
            }

            &__button {
                position: absolute;
                width: 36px;
                height: 36px;
                top: 10px;
                right: 10px;
                background: $colorPrimary;
                border-radius: 6px;
                cursor: pointer;

                @media (min-width: $breakpoint-sm) {
                    width: 40px;
                    height: 40px;
                    top: 12px;
                    right: 12px;
                }

                &:before {
                    content: '';
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    width: 16px;
                    height: 16px;
                    background: url('@/assets/ic_16_magnifier.svg');

                    @media (min-width: $breakpoint-sm) {
                        top: 12px;
                        left: 12px;
                    }
                }
            } 
        }

        &__empty {
            &__item {
                width: 100%;
                height: 80px;
                background-image: linear-gradient(135deg, rgba(15,12,14,0.04) 0%, rgba(15,12,14,0.02) 100%);
                border-radius: 12px;
                margin-top: 16px;

                @media (min-width: $breakpoint-sm) {
                    height: 128px;
                    margin-top: 24px;
                }

                &:nth-child(2) {
                    opacity: .64;
                }

                &:nth-child(3) {
                    opacity: .4;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    h1 {
        @media (min-width: $breakpoint-sm) {
            width: 100%;
            text-align: center;
        }
    }

    .news-card {
        margin-top: 16px;

        @media (min-width: $breakpoint-sm) {
            margin-top: 24px;
        }
    }
</style>